<template>
  <div class="contain">
    <div class="total-title">
      <img src="../../../../../../static/img/28.png" alt="" />
      <span> {{ title2 || '申请人合作情况' }} </span>
      <img src="../../../../../../static/img/21.png" alt="" />
    </div>
    <div class="echart-bg" :class="{ 'new-template': useNewGovTemplate }">
      <!-- <div class="num-text">合作专利总数:{{total}}</div> -->
      <div class="num-text">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiperSlide :key="index" v-for="(item, index) in relationChart">
            <div :title="item.name">{{ item.name }}: {{ item.value }}</div>
          </swiperSlide>
        </swiper>
      </div>
      <div ref="echart" class="echart"></div>
    </div>
  </div>
</template>

<script>
import { getValueCooperate, agencyRange } from '@/api/databaseBin'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BaseMixin from '@/views/_mixin'
import { mapState } from 'vuex'

export default {
  name: 'PCT',
  mixins: [BaseMixin],
  data: () => ({
    swiperOption: {
      init: false,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      direction: 'vertical',
      autoHeight: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1, // 页面中的板块数量
      autoplay: {
        delay: 2000
      },
      // autoplay: false,
      loop: true
    },
    option: {},
    cooperteEchart: null,
    total: null,
    value: [],
    compName: [],
    relationChart: [],
    name: null,
    textBr: null,
    swiperData: []
  }),
  components: { swiper, swiperSlide },
  computed: {
    ...mapState('title', ['title2']),
    ...mapState('user', ['useNewGovTemplate']),
    coopSwiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  async mounted() {
    this.initChart()
    window.addEventListener('resize', () => { this.resize() })
  },
  methods: {
    echartClick(params) {
      const name = params.name.split(':')
      if (params.componentType === 'radar') {
        console.log(name, 'name', params)
        if (this.useNewGovTemplate) {
          this.jumpIpi(`代理机构(精确)=(${name[0]}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
        } else {
          this.jumpIpi(`申请人数量>(1) and 申请人=（${name[0]}）`, 'isMerge', 'publicOrder')
        }
      }
    },
    async initChart() {
      this.cooperteEchart = this.$echarts.init(this.$refs.echart, null, { renderer: 'svg' })
      this.cooperteEchart.on('click', params => {
        this.echartClick(params)
      })
      if (this.useNewGovTemplate) {
        await this.getAgencyRange()
      } else {
        await this.getValue()
      }
      const option = {
        textStyle: {
          fontSize: this.useNewGovTemplate ? '14' : '12',
          color: '#fff'
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: (params) => {
            let text = this.name + '合作专利数' + '</br>'
            if (this.useNewGovTemplate) {
              text = ''
            }
            const color = ['#EF6896', '#6DC8EC', '#1E9493', '#5AD8A6', '#F6BD16']
            this.relationChart.forEach((item, i) => {
              text += `<div style="display: flex;align-items:center"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color[i]}"></span>` + '<div style="flex:1;display: flex;justify-content:space-between;align-items:center">' +
                item.name + `<span style="font-weight: 800">${item.value}</span></div></div>` + '</br>'
            })
            return text
          }
        },
        radar: {
          triggerEvent: true,
          indicator: this.compName,
          radius: this.useNewGovTemplate ? '63%' : '65%',
          axisName: {
            show: true,
            padding: [0, -5, -10, -5],
            formatter: (a, indicator) => {
              const name = indicator.text
              const value = indicator.value
              let newParamsName = ''
              const provideNumber = 8 // 一行显示几个字(中文字符)
              let currentLen = 0
              for (let i = 0; i < name.length; i++) {
                const char = name.charAt(i)
                const charLen = char.charCodeAt(0) > 255 ? 1 : 0.5
                if (currentLen + charLen > provideNumber) {
                  newParamsName += '\n'
                  currentLen = 0
                }
                newParamsName += char
                currentLen += charLen
              }
              return newParamsName + ':\n' + value
            }
          }
        },
        series: [
          {
            symbol: 'none', // 是否展示节点
            areaStyle: {
              color: '#68CAFE'
            },
            type: 'radar',
            data: [{
              value: this.value,
              name: this.name + '合作专利数'
            }],
            emphasis: {
              areaStyle: {
                color: '#68CAFE'
              }
            }
          }
        ]
      }
      this.cooperteEchart.setOption(option)
      this.$nextTick(() => {
        this.coopSwiper.init()
        setTimeout(() => this.resize(), 500)
      })
    },
    async getValue() {
      let query = {
        viewName: 'APPLICANT_COOPERATION_ANALYSIS',
        firstDim: 'COOPERATIVE_OBJ',
        querys: [
          {
            property: 'TOP_COOPERATIVE_PATENT_NUM',
            operation: 'LESS_EQUAL',
            value: '5'
          }
        ],
        measureFields: ['application_num']
      }
      if (this.isXZH) query = {}
      const data = await getValueCooperate(query)
      if (data[this.dataMapping]) {
        const { result: { relationChart } } = JSON.parse(data[this.dataMapping])
        this.total = relationChart.data[0].value
        this.name = relationChart.data[0].name
        const dataArr = []
        let max = 0
        relationChart.links.forEach(item => {
          item.name = item.target
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.target,
            value: item.value
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            value: item.value
          })
        })
        this.relationChart = relationChart.links
      }
    },
    async getAgencyRange() {
      const res = await agencyRange()
      if (res.code === 200) {
        const dataArr = []
        let max = 0
        res.data.forEach(item => {
          item.value = item.count
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.name,
            value: item.count
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            value: item.value
          })
        })
        this.relationChart = res.data
      }
    },
    resize() {
      this.cooperteEchart.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-wrapper {
  height: 42px !important;
  text-align: center !important;
  word-break: break-all;

  .swiper-slide {
    height: 42px !important;
  }
}

.echart-bg.new-template {
  .swiper-container {
    height: 22px !important;

    .swiper-wrapper {
      height: 22px !important;

      .swiper-slide {
        height: 22px !important;

        &>div {
          height: 100% !important;
        }
      }
    }
  }

  // .echart {
  //   margin-top: 45px !important;
  //   height: 255px !important;
  // }
}
</style>
